import { useMemo } from 'react';
import { useQueries } from 'react-query';
import { createQueriesData, createQueriesOptions } from './utils';

export const useHouseData = ({ importType, houseId }) => {
  const queriesOptions = useMemo(
    () => createQueriesOptions({ importType, houseId }),
    [importType, houseId]
  );

  const queries = useQueries(queriesOptions);

  const value = useMemo(() => createQueriesData(queries), [queries]);

  return value;
};
